<!-- 企业级-授权管理-设备中心 -->
<template>
  <div class="mainArea CDevieCenter">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="authCont">
          <div class="authLeft">
            <div class="tit">设备位置</div>
            <div class="authTree pd10">
              <el-tree
                class="defineTree"
                ref="tree"
                v-loading="sceneData.loading"
                highlight-current
                :data="sceneData.list"
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="defaultProps"
                @node-click="getNodeList">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span
                    class="label"
                    :class="data.space_id === sceneData.selected ? 'selected' : ''">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="authRight">
            <cdevicecomponent ref="cdevicecomponent"></cdevicecomponent>
          </div>
        </div>
      </div>
      
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { userApi, sceneApi, authApi } from "../../../../static/js/api.js"
  import cdevicecomponent from "./CDeviceComponent.vue"
  export default {
    name: 'CDeviceCenter',
    components: {
      CBreadCrumb,
      cdevicecomponent
    },

    data() {
      return {
        checkList:[],
        // 位置列表数据
        sceneData: {
          // 位置列表
          list: [],
          loading: false,
          selected:'',
        },

        // 树形控件配置
        defaultProps: {
          id:'space_id',
          children: 'children',
          label: 'space_name'
        },


        space_id:[],
        
      };
    },

    mounted(){

    },

    created: async function () {
      this.getSceneList()
    },

    methods: {
      
      //点击节点
      getNodeList(data){
        // console.log('data', data)
        // if (data.level < 1) return  // 汕头移动需注释
        this.sceneData.selected = data.space_id
        this.$store.state.spaceID = data.space_id.split(',')
      },

      // 获取位置列表
      getSceneList: async function () {
        let vm = this
        this.sceneData.loading=true
        let res = await sceneApi.space()
        this.sceneData.loading=false
        if (res.meta.code === 200) {
          // console.log(res.data)
          if(res.data!=''){
            vm.sceneData.list = res.data
            vm.sceneData.selected = res.data[0].space_id
            // vm.sceneData.selected = res.data[0].children[0].children[0].space_id // 汕头移动需注释
            this.$store.state.spaceID = vm.sceneData.selected.split(',')
          }
        } else {
          showToast(res.meta.message)
        }
      }
    },

    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },

    }
  }
</script>

<style lang="scss">
.CDevieCenter{
  .w110{ width: 110px;}
  .mt10{ margin-top: 10px;}
  .el-tree{
    background: #f0f0f0;
  }
  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background: none;
    // .label{
      // color: #409EFF;
    // }
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    .authCont{
      display: flex;
      min-height: 800px;
      .authLeft{
        overflow-y:auto;
        width: 305px;
        flex-shrink: 0;
        background: #f0f0f0;
        .tit{
          height: 48px;
          line-height: 48px;
          padding: 0 20px;
          background: #b5b5b5;
          font-size:24px;
          color: #666;
        }
        .pd10{ padding: 10px;}
      }
      .authRight{
        flex-grow:1;
        background-color: #f0f3f8;
        .operDiv{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .colRed{ color: red;}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CSceneManage/CDeviceCenter.vue